export default function useProductComposable() {
    function getShopLink(url: string): string {
        return import.meta.env.BB_FRONTEND_BASE_URL + url;
    }

    function getItemInfoLink(identifier: string): string {
        return import.meta.env.BB_BACKEND_BASE_URL + '/warehouse/item-info/index?search=' + encodeURIComponent(identifier);
    }

    function getAvailableColors(): Array<{ key: string, value: string|null }> {
        return [
            {
                key: 'red',
                value: '#FF0000',
            },
            {
                key: 'yellow',
                value: '#FFEB00',
            },
            {
                key: 'blue',
                value: '#0031FF',
            },
            {
                key: 'green',
                value: '#1FD300',
            },
            {
                key: 'pink',
                value: '#FF00D8',
            },
            {
                key: 'orange',
                value: '#FF7800',
            },
            {
                key: 'purple',
                value: '#7B00B1',
            },
            {
                key: 'cyan',
                value: '#88EBD4',
            },
            {
                key: 'brown',
                value: '#965100',
            },
            {
                key: 'grey',
                value: '#919191',
            },
            {
                key: 'white',
                value: '#FFFFFF',
            },
            {
                key: 'black',
                value: '#000000',
            },
            {
                key: 'multicolor',
                value: null,
            },
        ];
    }

    return {
        getShopLink,
        getItemInfoLink,
        getAvailableColors,
    };
}
